import { useInfiniteQuery } from '@tanstack/react-query';
import { sleep } from '../../utils/helpers';

const getPostedInvoicesMock = ({ invoiceStatus }) => {
    const status = invoiceStatus === 'pre-invoiced' ? 'PreInvoiced' : 'Invoiced';
    return {
        totalCount: 62,
        numberReturned: 12,
        pageSize: 20,
        offset: 0,
        data: [
            {
                invoiceNumber: 'AS1123451',
                bookingId: 1093489,
                bookingSfId: 1093489,
                clientName: 'Random very long client name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'Alan Ringel and Random name',
                clinicianSfId: null,
                collectorName: null,
                collectorSfId: null,
                numberOfLocations: 2,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status,
                amount: 445.05,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [],
                expenses: [
                    {
                        id: 12755,
                        type: 'Lodging',
                        merchantName: 'Fairfield Inn N Stes Marriott',
                        totalAmount: 445.05,
                        state: null,
                        rt: false,
                        postingDate: '2024-04-30T00:00:00',
                    },
                ],
                deposits: [],
                creditMemos: [],
            },
            {
                invoiceNumber: 'AS1123452',
                bookingId: 1112454,
                bookingSfId: null,
                clientName: 'Random name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'Tiffany Watkins',
                clinicianSfId: null,
                collectorName: null,
                collectorSfId: null,
                numberOfLocations: 1,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status,
                amount: 123.2,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [],
                expenses: [
                    {
                        id: 12778,
                        type: 'Lodging',
                        merchantName: 'Hampton Inn Andamp Suites Ale',
                        totalAmount: 252.76,
                        state: null,
                        rt: false,
                        postingDate: '2024-04-30T00:00:00',
                    },
                ],
                deposits: [],
                creditMemos: [],
            },
            {
                invoiceNumber: 'AS1123453',
                bookingId: 1118315,
                bookingSfId: null,
                clientName: 'Random name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'Integration Test',
                clinicianSfId: null,
                collectorName: null,
                collectorSfId: null,
                numberOfLocations: 1,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status,
                amount: 123.2,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [],
                expenses: [
                    {
                        id: 9275,
                        type: 'Mileage',
                        merchantName: 'Ed',
                        totalAmount: 2.0,
                        state: 'GA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 9685,
                        type: 'Mileage',
                        merchantName: 'Ed',
                        totalAmount: 0.0,
                        state: 'GA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 9686,
                        type: 'Mileage',
                        merchantName: 'Ed',
                        totalAmount: 0.0,
                        state: 'GA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 9689,
                        type: 'Application',
                        merchantName: 'Ed',
                        totalAmount: 100.0,
                        state: 'GA',
                        rt: false,
                        postingDate: null,
                    },
                ],
                deposits: [],
                creditMemos: [],
            },
            {
                invoiceNumber: 'AS1123454',
                bookingId: 1118321,
                bookingSfId: 1118321,
                clientName: 'Random name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'Blake Doctor Test',
                clinicianSfId: null,
                collectorName: null,
                collectorSfId: null,
                numberOfLocations: 3,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status,
                amount: 21,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [],
                expenses: [
                    {
                        id: 9381,
                        type: 'Air',
                        merchantName: 'ALASKA A',
                        totalAmount: 240.82,
                        state: 'GA',
                        rt: false,
                        postingDate: '2024-04-14T00:00:00',
                    },
                ],
                deposits: [],
                creditMemos: [],
            },
            {
                invoiceNumber: 'AS1123455',
                bookingId: 1118323,
                bookingSfId: null,
                clientName: 'Random name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'EdProvider Contact',
                clinicianSfId: null,
                collectorName: null,
                collectorSfId: null,
                numberOfLocations: 2,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status: 'Error',
                amount: 991,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [
                    {
                        id: 1232,
                        weekEnding: '2024-02-04T00:00:00',
                        rt: false,
                        totals: {
                            totalToBill: 12.0,
                            totalToPay: 4.4,
                            totalCost: 4.4,
                        },
                        hasErrors: true,
                        locations: [
                            {
                                name: 'Location 1',
                                locationId: 1,
                                lineItems: [
                                    {
                                        id: 6558,
                                        date: '2024-01-29T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: 12.0,
                                        billRate: 12.0,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 2.4,
                                        payRate: 2.4,
                                    },
                                    {
                                        id: 6559,
                                        date: '2024-01-29T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: null,
                                        billRate: null,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 1.0,
                                        payRate: 1.0,
                                    },
                                    {
                                        id: 6560,
                                        date: '2024-01-29T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: null,
                                        billRate: null,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 1.0,
                                        payRate: 1.0,
                                    },
                                ],
                            },
                            {
                                name: 'Location 2',
                                errorMessage:
                                    'This is an error alert. Put the description of your alert here.',
                                locationId: 2,
                                lineItems: [
                                    {
                                        id: 6558,
                                        date: '2024-01-29T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: 12.0,
                                        billRate: 12.0,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 2.4,
                                        payRate: 2.4,
                                    },
                                    {
                                        id: 6559,
                                        date: '2024-01-29T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: null,
                                        billRate: null,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 1.0,
                                        payRate: 1.0,
                                    },
                                    {
                                        id: 6560,
                                        date: '2024-01-29T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: null,
                                        billRate: null,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 1.0,
                                        payRate: 1.0,
                                    },
                                ],
                            },
                        ],
                    },
                ],
                expenses: [
                    {
                        id: 8149,
                        type: 'ClinicianGiftsRelations',
                        merchantName: 'Homewood Suites Sdf Airport',
                        totalAmount: 151.67,
                        state: 'KS',
                        rt: false,
                        postingDate: '2024-04-30T00:00:00',
                    },
                    {
                        id: 124070,
                        type: 'Rent',
                        merchantName: null,
                        totalAmount: 12.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124081,
                        type: 'MedicalStaffDues',
                        merchantName: null,
                        totalAmount: 53.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124103,
                        type: 'BackgroundCheck',
                        merchantName: null,
                        totalAmount: 78.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124107,
                        type: 'Verification',
                        merchantName: null,
                        totalAmount: 354.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 9694,
                        type: 'PSYCMalpracticeCompFund',
                        merchantName: 'Homewood Suites Sdf Airport',
                        totalAmount: 0.0,
                        state: 'KS',
                        rt: false,
                        postingDate: '2024-04-30T00:00:00',
                    },
                    {
                        id: 9366,
                        type: 'CustomerCareGiftsFlowers',
                        merchantName: 'Towneplace Stes Olymp Marriott',
                        totalAmount: null,
                        state: 'KS',
                        rt: false,
                        postingDate: '2024-04-30T00:00:00',
                    },
                    {
                        id: 9374,
                        type: 'UnidentifiedLicensing',
                        merchantName: 'Towneplace Stes Olymp Marriott',
                        totalAmount: null,
                        state: 'KS',
                        rt: false,
                        postingDate: '2024-04-30T00:00:00',
                    },
                    {
                        id: 9375,
                        type: 'Lodging',
                        merchantName: 'Towneplace Stes Olymp Marriott',
                        totalAmount: null,
                        state: 'KS',
                        rt: false,
                        postingDate: '2024-04-30T00:00:00',
                    },
                    {
                        id: 9376,
                        type: 'UnidentifiedLicensing',
                        merchantName: 'Towneplace Stes Olymp Marriott  4',
                        totalAmount: null,
                        state: 'KS',
                        rt: false,
                        postingDate: '2024-04-30T00:00:00',
                    },
                    {
                        id: 122412,
                        type: 'Application',
                        merchantName: null,
                        totalAmount: 213.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 122510,
                        type: 'ApplicationFee',
                        merchantName: null,
                        totalAmount: 10.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 122733,
                        type: 'Fingerprinting',
                        merchantName: null,
                        totalAmount: 100.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 122790,
                        type: 'Fingerprinting',
                        merchantName: null,
                        totalAmount: 199.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 122952,
                        type: 'Fingerprinting',
                        merchantName: null,
                        totalAmount: 160.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 122953,
                        type: 'Application',
                        merchantName: null,
                        totalAmount: 120.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 122954,
                        type: 'Fingerprinting',
                        merchantName: null,
                        totalAmount: 199.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 122955,
                        type: 'Fingerprinting',
                        merchantName: null,
                        totalAmount: 200.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 123722,
                        type: 'Other',
                        merchantName: null,
                        totalAmount: 0.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 123768,
                        type: 'Application',
                        merchantName: null,
                        totalAmount: 123.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 123859,
                        type: 'MedicalStaffDues',
                        merchantName: null,
                        totalAmount: 145.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 123889,
                        type: 'Fingerprinting',
                        merchantName: null,
                        totalAmount: 567.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 123894,
                        type: 'Fingerprinting',
                        merchantName: null,
                        totalAmount: 987.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 123901,
                        type: 'Rent',
                        merchantName: null,
                        totalAmount: 300.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 123973,
                        type: 'BackgroundCheck',
                        merchantName: 'FS PACKAGE 1',
                        totalAmount: 100.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124007,
                        type: 'BackgroundCheck',
                        merchantName: 'FS PACKAGE 1',
                        totalAmount: 100.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124022,
                        type: 'Verification',
                        merchantName: null,
                        totalAmount: 96.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124024,
                        type: 'BackgroundCheck',
                        merchantName: 'FS PACKAGE 1',
                        totalAmount: 100.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124029,
                        type: 'LabWorkXRay',
                        merchantName: 'XR X-Ray Chest 1 View',
                        totalAmount: 300.23,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124031,
                        type: 'Verification',
                        merchantName: null,
                        totalAmount: 58.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124042,
                        type: 'BackgroundCheck',
                        merchantName: 'FS PACKAGE 1',
                        totalAmount: 100.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124047,
                        type: 'LabWorkXRay',
                        merchantName: 'XR X-Ray Chest 1 View',
                        totalAmount: 300.23,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124052,
                        type: 'Rent',
                        merchantName: null,
                        totalAmount: 34.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124053,
                        type: 'Rent',
                        merchantName: null,
                        totalAmount: 65.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124059,
                        type: 'BackgroundCheck',
                        merchantName: 'FS PACKAGE 1',
                        totalAmount: 100.0,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 124064,
                        type: 'LabWorkXRay',
                        merchantName: 'XR X-Ray Chest 1 View',
                        totalAmount: 300.23,
                        state: 'CA',
                        rt: false,
                        postingDate: null,
                    },
                ],
                deposits: [],
                creditMemos: [],
            },
            {
                invoiceNumber: 'AS1123456',
                bookingId: 1118398,
                bookingSfId: 1118398,
                clientName: 'Random name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'Chance Ball',
                clinicianSfId: '003QL000007cAGwYAM',
                collectorName: null,
                collectorSfId: null,
                numberOfLocations: 1,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status,
                amount: 52,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [
                    {
                        id: 1435,
                        weekEnding: '2024-03-17T00:00:00',
                        rt: false,
                        totals: {
                            totalToBill: 120.0,
                            totalToPay: 456.0,
                            totalCost: 456.0,
                        },
                        locations: [
                            {
                                name: 'Location 1',
                                locationId: 1,
                                lineItems: [
                                    {
                                        id: 76811,
                                        date: '2024-03-11T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: 100.0,
                                        billRate: 100.0,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 56.0,
                                        payRate: 56.0,
                                    },
                                    {
                                        id: 76821,
                                        date: '2024-03-11T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: 20.0,
                                        billRate: 20.0,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: null,
                                        payRate: null,
                                    },
                                    {
                                        id: 76831,
                                        date: '2024-03-11T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: null,
                                        billRate: null,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 200.0,
                                        payRate: 200.0,
                                    },
                                    {
                                        id: 76841,
                                        date: '2024-03-11T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: null,
                                        billRate: null,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 200.0,
                                        payRate: 200.0,
                                    },
                                ],
                            },
                            {
                                name: 'Location 2',
                                locationId: 2,
                                lineItems: [
                                    {
                                        id: 76812,
                                        date: '2024-03-11T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: 100.0,
                                        billRate: 100.0,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 56.0,
                                        payRate: 56.0,
                                    },
                                    {
                                        id: 76822,
                                        date: '2024-03-11T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: 20.0,
                                        billRate: 20.0,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: null,
                                        payRate: null,
                                    },
                                    {
                                        id: 76832,
                                        date: '2024-03-11T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: null,
                                        billRate: null,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 200.0,
                                        payRate: 200.0,
                                    },
                                    {
                                        id: 76842,
                                        date: '2024-03-11T00:00:00',
                                        rateType: null,
                                        billTime: null,
                                        billUnit: null,
                                        billAmount: null,
                                        billRate: null,
                                        payTime: null,
                                        payUnit: null,
                                        payAmount: 200.0,
                                        payRate: 200.0,
                                    },
                                ],
                            },
                        ],
                    },
                ],
                expenses: [],
                deposits: [],
                creditMemos: [],
            },
            {
                invoiceNumber: 'AS1123457',
                bookingId: 1118798,
                bookingSfId: null,
                clientName: 'Random name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'Jeremy Berven',
                clinicianSfId: null,
                collectorName: 'Irene Gorbaciova',
                collectorSfId: null,
                numberOfLocations: 4,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status,
                amount: 123,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [],
                expenses: [
                    {
                        id: 91840,
                        type: 'Application',
                        merchantName: 'Berv Image Test',
                        totalAmount: 20.0,
                        state: 'GA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 111799,
                        type: 'Application',
                        merchantName: 'Test',
                        totalAmount: 0.0,
                        state: 'GA',
                        rt: false,
                        postingDate: null,
                    },
                    {
                        id: 111840,
                        type: 'Application',
                        merchantName: 'Berv Image Test',
                        totalAmount: 20.0,
                        state: 'GA',
                        rt: false,
                        postingDate: null,
                    },
                ],
                deposits: [],
                creditMemos: [],
            },
            {
                invoiceNumber: 'AS1123458',
                bookingId: 1118800,
                bookingSfId: null,
                clientName: 'Random name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'Mario Bolanos',
                clinicianSfId: null,
                collectorName: 'Import User',
                collectorSfId: null,
                numberOfLocations: 3,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status,
                amount: 456,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [],
                expenses: [
                    {
                        id: 123817,
                        type: 'BackgroundCheck',
                        merchantName: 'FS PACKAGE 1',
                        totalAmount: 150.0,
                        state: 'MN',
                        rt: false,
                        postingDate: null,
                    },
                ],
                deposits: [],
                creditMemos: [],
            },
            {
                invoiceNumber: 'AS1123459',
                bookingId: 1119317,
                bookingSfId: null,
                clientName: 'Random name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'Ryan Henry',
                clinicianSfId: null,
                collectorName: null,
                collectorSfId: null,
                numberOfLocations: 2,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status: 'Abandoned',
                amount: 1118.22,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [],
                expenses: [
                    {
                        id: 12630,
                        type: 'Lodging',
                        merchantName: 'Residence Morgantown Marriott',
                        totalAmount: 1118.22,
                        state: null,
                        rt: false,
                        postingDate: '2024-04-30T00:00:00',
                    },
                ],
                deposits: [],
                creditMemos: [],
            },
            {
                invoiceNumber: 'AS11234510',
                bookingId: 1126082,
                bookingSfId: null,
                clientName: 'Random name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'Eve Seagal',
                clinicianSfId: null,
                collectorName: null,
                collectorSfId: null,
                numberOfLocations: 2,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status: 'Error',
                amount: 638.81,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [],
                expenses: [
                    {
                        id: 7964,
                        type: 'Air',
                        merchantName: 'ALASKA A',
                        totalAmount: null,
                        state: null,
                        rt: false,
                        postingDate: '2024-04-14T00:00:00',
                    },
                ],
                deposits: [],
                creditMemos: [],
            },
            {
                invoiceNumber: 'AS11234511',
                bookingId: 1127523,
                bookingSfId: null,
                clientName: 'Random name',
                customerNumber: 'LT-12078-B-077204',
                clinicianName: 'Virginia Johnson',
                clinicianSfId: null,
                collectorName: null,
                collectorSfId: null,
                numberOfLocations: 2,
                invoiceDate: '2024-04-30T00:00:00',
                postedDate: '2024-04-30T00:00:00',
                status: 'Outdated',
                amount: 123,
                invoiceTypes: ['General'],
                specialProcessing: null,
                timesheets: [],
                expenses: [
                    {
                        id: 12783,
                        type: 'Lodging',
                        merchantName: 'Holiday Inn Exp Stes Civic Cen',
                        totalAmount: 638.81,
                        state: null,
                        rt: false,
                        postingDate: '2024-04-30T00:00:00',
                    },
                ],
                deposits: [],
                creditMemos: [],
            },
        ],
    };
};

const useGetInvoices = (params, options) =>
    useInfiniteQuery({
        queryKey: ['getPostedInvoices', params],
        queryFn: async ({ pageParam: offset = 0 }) => {
            await sleep(1500);
            return getPostedInvoicesMock(params);
        },
        getNextPageParam: (lastResponse) => {
            const displayedItems = lastResponse.offset + lastResponse.numberReturned;
            const nextOffset =
                displayedItems < lastResponse.totalCount
                    ? lastResponse.offset + params.pageSize
                    : undefined;
            return nextOffset;
        },
        ...options,
    });

export default useGetInvoices;
